export const ROUTES = {
  auth: {
    login: {
      path: '/login',
    },
    forgotPassword: {
      path: '/forgot-password',
    },
    resetPassword: {
      path: '/reset-password',
    },
  },
  geofence: {
    fullPath: '/geofence',
    path: '/geofence',
    create: {
      fullPath: '/geofence/create',
      path: '/create',
    },
    edit: {
      getPath: (id: string) => `/geofence/edit/${id}`,
      path: '/edit/:id',
      fullPath: '/geofence/edit/:id',
    },
  },
  places: {
    fullPath: '/places/*',
    path: '/places',
    locations: {
      path: '/locations',
      fullPath: '/places/locations',
    },
    groups: {
      path: '/groups',
      fullPath: '/places/groups',
    },
  },
  protocols: {
    fullPath: '/protocols/*',
    path: '/protocols',
    rules: {
      path: '/rules',
      fullPath: '/protocols/rules',
    },
    alerts: {
      path: '/alerts',
      fullPath: '/protocols/alerts',
      searchParams: {
        reportOption: 'reportOption',
        alertId: 'alertId',
        transportId: 'transportId',
        startTime: 'startTime',
        endTime: 'endTime',
        tripID: 'tripID',
        type: 'type',
        vehicles: 'vehicle',
        couriers: 'courier',
      },
    },
  },
  personnel: {
    path: '/personnel',
    fullPath: '/personnel/*',
    vehicles: {
      path: '/vehicles',
      fullPath: '/personnel/vehicles',
    },
    teams: {
      path: '/teams',
      fullPath: '/personnel/teams',
    },
    devices: {
      path: '/devices',
      fullPath: '/personnel/devices',
    },
  },
  drivers: {
    path: '/drivers',
    fullPath: '/drivers/*',
  },
  admin: {
    path: '/admin',
    fullPath: '/admin/*',
    users: {
      path: '/user-management',
      fullPath: '/admin/user-management',
    },
    roles: {
      path: '/role-management',
      fullPath: '/admin/role-management',
    },
  },
  monitoring: {
    path: '/monitoring',
    fullPath: '/monitoring/*',
    searchParams: {
      transportID: 'transportID',
      courierID: 'courierID',
      startDate: 'startDate',
      endDate: 'endDate',
      tripID: 'tripID',
      startHour: 'startHour',
      endHour: 'endHour',
      excludeWeekends: 'excludeWeekends',
      dateFilter: 'dateFilter',
      exactTripID: 'exactTripID',
    },
  },
  reporting: {
    path: '/reporting/',
    fullPath: '/reporting/*',
    searchParams: {
      transports: 'transports',
      start: 'start',
      end: 'end',
      startHour: 'startHour',
      endHour: 'endHour',
      excludeWeekends: 'excludeWeekends',
      dateFilterLabel: 'dateFilterLabel',
      filtersApplied: 'filtersApplied',
      sortBy: 'sortBy',
      sortDirection: 'sortDirection',
      drawerExpanded: 'drawerExpanded',
    },
    visitedLocations: {
      path: '/visited-locations',
      fullPath: '/reporting/visited-locations',
      searchParams: {
        locations: 'locations',
        groups: 'groups',
        radius: 'radius',
        stopPeriod: 'stopPeriod',
        status: 'status',
        activeReport: 'activeReport',
      },
    },
    dailyWorkdayDuration: {
      path: '/daily-workday-duration',
      fullPath: '/reporting/daily-workday-duration',
      searchParams: {
        hideMissingDays: 'hideMissingDays',
        showWeekdaysOnly: 'showWeekdaysOnly',
      },
    },
    conditionalEvents: {
      path: '/conditional-events',
      fullPath: '/reporting/conditional-events',
      searchParams: {
        eventType: 'eventType',
        moreThanValue: 'moreThanValue',
        lessThanValue: 'lessThanValue',
        duration: 'duration',
        resolve: 'resolve',
        activeTransports: 'activeTransports',
      },
    },
    vehicleGeofenceReport: {
      path: '/vehicle-geofence',
      fullPath: '/reporting/vehicle-geofence',
      searchParams: {
        geofences: 'geofences',
        duration: 'duration',
        penetration: 'penetration',
        eventType: 'eventType',
        status: 'status',
        activeReport: 'activeReport',
      },
    },
    trips: {
      path: '/trips',
      fullPath: '/reporting/trips',
      searchParams: {
        groupByDays: 'groupByDays',
        duration: 'duration',
        distanceRange: 'distanceRange',
        activeReport: 'activeReport',
        activeGroup: 'activeGroup',
      },
    },
  },
};
